"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectDeepCopy = void 0;
/**
 * Głębokie kopiowanie
 * @param data date do skopiowania
 */
function objectDeepCopy(data) {
    return JSON.parse(JSON.stringify(data));
}
exports.objectDeepCopy = objectDeepCopy;
//# sourceMappingURL=objectDeepCopy.js.map